(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq-homepage"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (event) {
    var btn = event.target.closest('.nl-hp-faq__btn');
    if (!btn) return;
    var item = btn.closest('.nl-hp-faq__item');
    if (!item) return;
    var isOpen = item.classList.toggle('is-open');
    btn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nl-faq-page"]) return;
  try {
    
  document.addEventListener('click', function (event) {
    var btn = event.target.closest('.nl-faqp__btn');
    if (!btn) return;
    var item = btn.closest('.nl-faqp__item');
    if (!item) return;
    var isOpen = item.classList.toggle('is-open');
    btn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
  });

  } catch(e) { console.error(e); }
})();
})();
